"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.gqlUrl = exports.apiGatewayUrl = exports.Region = exports.pathToClientIdMap = exports.AtoZClientId = void 0;
var atoz_shiftapp_initializer_1 = require("@amzn/atoz-shiftapp-initializer");
var atoz_time_and_attendance_1 = require("@amzn/atoz-time-and-attendance");
var atoz_shiftapp_initializer_2 = require("@amzn/atoz-shiftapp-initializer");
var AtoZClientId;
(function (AtoZClientId) {
    //TODO update if when it's finalized
    AtoZClientId["SCHEDULE_MANAGEMENT"] = "SCHEDULE_MANAGEMENT_SERVICE";
    AtoZClientId["TIME_OFF"] = "ATOZ_TIMEOFF_SERVICE";
    AtoZClientId["PAY_BREAKDOWN"] = "ATOZ_PAY_BREAKDOWN";
})(AtoZClientId = exports.AtoZClientId || (exports.AtoZClientId = {}));
exports.pathToClientIdMap = (_a = {},
    _a[atoz_time_and_attendance_1.ApiRoot.Punches] = AtoZClientId.TIME_OFF,
    _a[atoz_time_and_attendance_1.ApiRoot.SubmitMissingPunch] = AtoZClientId.TIME_OFF,
    _a[atoz_time_and_attendance_1.ApiRoot.PunchCorrections] = AtoZClientId.TIME_OFF,
    _a[atoz_time_and_attendance_1.ApiRoot.TimeoffPayPeriod] = AtoZClientId.TIME_OFF,
    _a[atoz_shiftapp_initializer_1.ApiRoot.PayCalendar] = AtoZClientId.PAY_BREAKDOWN,
    _a[atoz_shiftapp_initializer_1.ApiRoot.PayRates] = AtoZClientId.PAY_BREAKDOWN,
    _a[atoz_shiftapp_initializer_1.ApiRoot.Timeoff] = AtoZClientId.TIME_OFF,
    _a);
var Region;
(function (Region) {
    Region["usWest"] = "usWest";
    Region["usEast"] = "usEast";
})(Region = exports.Region || (exports.Region = {}));
exports.apiGatewayUrl = {
    usWest: {
        dev: 'http://0.0.0.0:4000',
        essp: 'https://atoz-api.integ.amazon.com',
        beta: 'https://atoz-api.integ.amazon.com',
        gamma: 'https://atoz-api.integ.amazon.com',
        prod: 'https://atoz-api.amazon.work'
    },
    usEast: {
        dev: 'http://0.0.0.0:4000',
        essp: 'https://atoz-api-us-east-1.integ.amazon.com',
        beta: 'https://atoz-api-us-east-1.integ.amazon.com',
        gamma: 'https://atoz-api-us-east-1.integ.amazon.com',
        prod: 'https://atoz-api-us-east-1.amazon.work'
    }
};
exports.gqlUrl = {
    usWest: {
        dev: "".concat(exports.apiGatewayUrl[Region.usWest][atoz_shiftapp_initializer_2.Stage.DEV], "/graphql"),
        essp: "".concat(exports.apiGatewayUrl[Region.usWest][atoz_shiftapp_initializer_2.Stage.ESSP], "/graphql"),
        beta: "".concat(exports.apiGatewayUrl[Region.usWest][atoz_shiftapp_initializer_2.Stage.BETA], "/graphql"),
        gamma: "".concat(exports.apiGatewayUrl[Region.usWest][atoz_shiftapp_initializer_2.Stage.GAMMA], "/graphql"),
        prod: "".concat(exports.apiGatewayUrl[Region.usWest][atoz_shiftapp_initializer_2.Stage.PROD], "/graphql")
    },
    usEast: {
        dev: "".concat(exports.apiGatewayUrl[Region.usEast][atoz_shiftapp_initializer_2.Stage.DEV], "/graphql"),
        essp: "".concat(exports.apiGatewayUrl[Region.usEast][atoz_shiftapp_initializer_2.Stage.ESSP], "/graphql"),
        beta: "".concat(exports.apiGatewayUrl[Region.usEast][atoz_shiftapp_initializer_2.Stage.BETA], "/graphql"),
        gamma: "".concat(exports.apiGatewayUrl[Region.usEast][atoz_shiftapp_initializer_2.Stage.GAMMA], "/graphql"),
        prod: "".concat(exports.apiGatewayUrl[Region.usEast][atoz_shiftapp_initializer_2.Stage.PROD], "/graphql")
    }
};
